import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Tag as TagIcon, Download, Loader2 } from 'lucide-react';
import { crmTagsApi, CrmTag } from '../services/crmApi';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { toast } from 'sonner';
export function TagDetail() {
  const {
    tagName
  } = useParams<{
    tagName: string;
  }>();
  const {
    getSubmissionsByTag
  } = useWorkspace();
  const [tag, setTag] = useState<CrmTag | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchTag = async () => {
      setLoading(true);
      try {
        const tags = await crmTagsApi.list();
        const found = tags.find(t => t.Name === tagName);
        setTag(found || null);
      } catch (err) {
        console.error('Failed to fetch tag:', err);
        toast.error('Failed to load tag details');
      } finally {
        setLoading(false);
      }
    };
    fetchTag();
  }, [tagName]);
  const submissions = getSubmissionsByTag(tagName || '');
  if (loading) {
    return <div className="flex items-center justify-center py-24" data-id="element-6783" data-mp="965cl8n0yet9">
        <Loader2 className="h-8 w-8 text-blue-500 animate-spin" data-id="element-6784" data-mp="44pot8tgpu76" />
        <span className="ml-3 text-sm text-gray-500" data-id="element-6785" data-mp="j31kpd90gyxa">
          Loading tag details...
        </span>
      </div>;
  }
  return <div className="space-y-6" data-id="element-6786" data-mp="e3yf9rp4cqos">
      <div className="flex items-center justify-between" data-id="element-6787" data-mp="e1knpstndwlz">
        <div className="flex items-center gap-4" data-id="element-6788" data-mp="3mk0be66yjlkq">
          <Link to="/tags" className="p-2 hover:bg-gray-100 rounded-full text-gray-500" data-id="element-6789" data-mp="3hk5la4v0b00q">
            <ArrowLeft className="h-5 w-5" data-id="element-6790" data-mp="3w04d874bd8" />
          </Link>
          <div data-id="element-6791" data-mp="5gxealwa8es">
            <div className="flex items-center gap-3" data-id="element-6792" data-mp="3rilc06q4g79p">
              <h1 className="text-2xl font-semibold text-gray-900" data-id="element-6793" data-mp="3rgqlmcw2zmy8">Tag:</h1>
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium bg-blue-50 text-blue-700 border border-blue-200" data-id="element-6794" data-mp="33rpcenffc7rw">
                <TagIcon className="h-3.5 w-3.5" data-id="element-6795" data-mp="3ohrt0wjty8w0" />
                {tag?.Name || tagName}
              </span>
            </div>
            <p className="mt-1 text-sm text-gray-500" data-id="element-6796" data-mp="3silj9wkqvzs2">
              {tag ? `Team: ${tag.Team || '—'}` : 'Tag not found in CRM'}
            </p>
          </div>
        </div>
        <button className="inline-flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50" data-id="element-6797" data-mp="63sn2zkvpjqz">
          <Download className="h-4 w-4" data-id="element-6798" data-mp="35kqofcu6uasl" />
          Export
        </button>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-6799" data-mp="39l14xjflwjlp">
        {submissions.length === 0 ? <div className="p-12 text-center" data-id="element-6800" data-mp="3elovy53u50fx">
            <TagIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-6801" data-mp="3jiyr81dwo6bo" />
            <h3 className="mt-2 text-sm font-semibold text-gray-900" data-id="element-6802" data-mp="ttd9jsg8qz50">
              No submissions found
            </h3>
            <p className="mt-1 text-sm text-gray-500" data-id="element-6803" data-mp="yry9rrvhtitg">
              No submissions have been tagged with "{tagName}".
            </p>
          </div> : <table className="min-w-full divide-y divide-gray-200" data-id="element-6804" data-mp="2jclbnzukln99">
            <thead className="bg-gray-50" data-id="element-6805" data-mp="2ecqgvl7ocdix">
              <tr data-id="element-6806" data-mp="29kp9aclgbaz8">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6807" data-mp="29k73opcwfken">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6808" data-mp="24lce94kfexlk">
                  Email
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6809" data-mp="1vko6grlmlth4">
                  Source Form
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6810" data-mp="1lmrnxeqczw8z">
                  All Tags
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6811" data-mp="3kzc9i28btz2h">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-6812" data-mp="3o2s2orply78f">
              {submissions.map(sub => <tr key={sub.id} className="hover:bg-gray-50" data-id="element-6813" data-mp="3szsc9clo1s4a">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-6814" data-mp="3e42k0wpw0ir4">
                    {sub.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-6815" data-mp="3j0jb9zsdvd8f">
                    {sub.email}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-6816" data-mp="3a27j3tbvc7dv">
                    {sub.form}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-6817" data-mp="2vecpmaq1dyzq">
                    <div className="flex flex-wrap gap-1" data-id="element-6818" data-mp="30b38t6x51apd">
                      {sub.tags?.map(t => <Link key={t} to={`/tags/${t}`} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium ${t === tagName ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-700'}`} data-id="element-6819" data-mp="2md67xybnii4w">
                          <TagIcon className="h-3 w-3" data-id="element-6820" data-mp="22rwak3pmdxd8" />
                          {t}
                        </Link>)}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-6821" data-mp="2bq8aiwcdm7ic">
                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${sub.status === 'accepted' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-6822" data-mp="2qnqvropui2l1">
                      {sub.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>}
      </div>
    </div>;
}